var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('v-container',{class:_vm.scrollArrowClass,style:(_vm.scrollArrowStyle)},[_c('v-btn',{staticClass:"arrow-button ma-5",attrs:{"id":"scroll-up-down","active-class":"no-active","fab":"","ripple":false,"depressed":"","color":_vm.buttonColor},on:{"click":_vm.onClick}},[_c('v-icon',[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }